import type React from 'react'

const FileIconZip: React.FC = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.125 0.625V4.875H13.375L9.125 0.625ZM8.0625 4.875V0.625H2.21875C1.32227 0.625 0.625 1.35547 0.625 2.21875V16.0312C0.625 16.9277 1.32227 17.625 2.21875 17.625H11.7812C12.6445 17.625 13.375 16.9277 13.375 16.0312V5.9375H9.125C8.52734 5.9375 8.0625 5.47266 8.0625 4.875ZM3.8125 1.6875H5.9375V2.75H3.8125V1.6875ZM3.8125 3.8125H5.9375V4.875H3.8125V3.8125ZM3.8125 5.9375H5.9375V7H3.8125V5.9375ZM4.875 14.4375C3.51367 14.4375 2.51758 13.209 2.7832 11.9141L3.8125 8.0625H5.9375L6.93359 11.9473C7.19922 13.2422 6.20312 14.4375 4.875 14.4375ZM5.40625 11.7812H4.34375C4.04492 11.7812 3.8125 12.0469 3.8125 12.3125C3.8125 12.6113 4.04492 12.8438 4.34375 12.8438H5.40625C5.67188 12.8438 5.9375 12.6113 5.9375 12.3125C5.9375 12.0469 5.67188 11.7812 5.40625 11.7812Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FileIconZip
